import Menu from 'semantic-ui-react/dist/commonjs/collections/Menu';
import '@purple/semantic-ui-purple-theme/components/menu.css';

export default Menu;
